 
 
  import { useEffect, useState, useCallback } from "react";
import {
  Box, Typography, Paper, CircularProgress, Alert,
  Table, TableHead, TableRow, TableCell, TableBody,
  Grid, TextField, Button, MenuItem,
  Dialog
} from "@mui/material";
import { stockService } from "../service/CreateStockService";
import api from "../service/api";

const CURRENT_YEAR  = new Date().getFullYear();
const CURRENT_MONTH = new Date().getMonth() + 1; // 1-based

const ReturnBike = () => {

  const [data,     setData]     = useState([]);
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");
  const [openView, setOpenView] = useState(false);
  const [viewData, setViewData] = useState(null);

  const [filters, setFilters] = useState({
    model:    "",
    skuCode:  "",
    colour:   "",
    location: "",
    source:   "",
    fromDate: "",
    toDate:   "",
    month:    String(CURRENT_MONTH),   // ✅ default = current month
    year:     String(CURRENT_YEAR),    // ✅ default = current year
    engine:   "",
    chasis:   "",
    search:   "",
    status:   "RETURN"
  });

  const handleChange = (e) =>
    setFilters((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  /* ─────────────────────────────────────────────────────────────
     Build clean query — strip empty strings, auto-fix edge cases
  ───────────────────────────────────────────────────────────── */
  const buildQuery = (f) => {
    const q = { ...f };

    // Always force RETURN
    q.status = "RETURN";

    // Month needs year — auto-fill if missing
    if (q.month && !q.year) {
      q.year = String(CURRENT_YEAR);
    }

    // Date range takes priority — drop month/year to avoid backend conflict
    if (q.fromDate && q.toDate) {
      q.month = "";
      q.year  = "";
    }

    // Remove empty strings so backend ignores them
    Object.keys(q).forEach((k) => {
      if (q[k] === "" || q[k] == null) delete q[k];
    });

    return q;
  };
//test return bike by engine
  const fetchStock = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const query = buildQuery(filters);
      const res   = await stockService.filterStock(query);
      const bikes = res?.data || [];

      // Group by location
      const grouped = {};
      bikes.forEach((bike) => {
        const loc = bike.location || "Unknown";
        if (!grouped[loc]) grouped[loc] = { location: loc, bikes: [], total: 0 };
        grouped[loc].bikes.push(bike);
        grouped[loc].total++;
      });

      setData(Object.values(grouped));
    } catch (err) {
      console.error("Fetch error:", err);
      setError("Failed to load stock");
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => { fetchStock(); }, [fetchStock]);
 const handleView = async (id) => {
    try {
      setOpenView(true);
      const res = await api.get(`/specific-bike-details/${id}`);
      setViewData(res?.data?.data || null);
     } catch {
      setError("Failed to load details");
    }
  };
  const resetFilters = () =>
    setFilters({
      model: "", skuCode: "", colour: "", location: "",
      source: "", fromDate: "", toDate: "",
      month:  String(CURRENT_MONTH),
      year:   String(CURRENT_YEAR),
      engine: "", chasis: "", search: "",
      status: "RETURN"
    });

  // Active filter label shown in page header
  const activeFilterLabel = () => {
    if (filters.fromDate && filters.toDate)
      return `${filters.fromDate} → ${filters.toDate}`;
    if (filters.month && filters.year)
      return `${new Date(0, Number(filters.month) - 1).toLocaleString("default", { month: "long" })} ${filters.year}`;
    if (filters.year)  return `Year ${filters.year}`;
    if (filters.month) return new Date(0, Number(filters.month) - 1).toLocaleString("default", { month: "long" });
    return "All Time";
  };

  return (
    <Box sx={{ maxWidth: "1200px", mx: "auto", px: 2 }}>

      <Typography variant="h4" gutterBottom>
        Return Bikes —{" "}
        <Typography component="span" variant="h5" color="primary">
          {activeFilterLabel()}
        </Typography>
      </Typography>

      {/* FILTERS */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2}>

          <Grid item xs={6} md={2}>
            <TextField label="Model" name="model" fullWidth size="small"
              value={filters.model} onChange={handleChange} />
          </Grid>

          <Grid item xs={6} md={2}>
            <TextField label="SKU" name="skuCode" fullWidth size="small"
              value={filters.skuCode} onChange={handleChange} />
          </Grid>

          <Grid item xs={6} md={2}>
            <TextField label="Colour" name="colour" fullWidth size="small"
              value={filters.colour} onChange={handleChange} />
          </Grid>

          <Grid item xs={6} md={2}>
            <TextField select label="Location" name="location" fullWidth size="small"
              value={filters.location} onChange={handleChange}>
              <MenuItem value="">All</MenuItem>
              <MenuItem value="Khejuri">Khejuri</MenuItem>
              <MenuItem value="Chaitanyapur">Chaitanyapur</MenuItem>
              <MenuItem value="Nandigram">Nandigram</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={6} md={2}>
            <TextField label="Engine No" name="engine" fullWidth size="small"
              value={filters.engine} onChange={handleChange} />
          </Grid>

          <Grid item xs={6} md={2}>
            <TextField label="Chasis No" name="chasis" fullWidth size="small"
              value={filters.chasis} onChange={handleChange} />
          </Grid>

          {/* DATE RANGE — clears month/year when used */}
          <Grid item xs={6} md={2}>
            <TextField type="date" label="From Date" name="fromDate" fullWidth size="small"
              InputLabelProps={{ shrink: true }}
              value={filters.fromDate}
              onChange={(e) =>
                setFilters((p) => ({ ...p, fromDate: e.target.value, month: "", year: "" }))
              } />
          </Grid>

          <Grid item xs={6} md={2}>
            <TextField type="date" label="To Date" name="toDate" fullWidth size="small"
              InputLabelProps={{ shrink: true }}
              value={filters.toDate}
              onChange={(e) =>
                setFilters((p) => ({ ...p, toDate: e.target.value, month: "", year: "" }))
              } />
          </Grid>

          {/* MONTH — clears date range, auto-fills year */}
          <Grid item xs={6} md={2}>
            <TextField select label="Month" name="month" fullWidth size="small"
              value={filters.month}
              onChange={(e) =>
                setFilters((p) => ({
                  ...p,
                  month:    e.target.value,
                  fromDate: "",
                  toDate:   "",
                  year:     p.year || String(CURRENT_YEAR)  // auto-fill year
                }))
              }>
              <MenuItem value="">All Months</MenuItem>
              {[...Array(12)].map((_, i) => (
                <MenuItem key={i + 1} value={String(i + 1)}>
                  {new Date(0, i).toLocaleString("default", { month: "long" })}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {/* YEAR — clears date range */}
          <Grid item xs={6} md={2}>
            <TextField type="number" label="Year" name="year" fullWidth size="small"
              value={filters.year}
              onChange={(e) =>
                setFilters((p) => ({ ...p, year: e.target.value, fromDate: "", toDate: "" }))
              } />
          </Grid>

          <Grid item xs={6} md={2}>
            <TextField label="Search" name="search" fullWidth size="small"
              value={filters.search} onChange={handleChange} />
          </Grid>

          <Grid item xs={6} md={2}>
            <Button fullWidth variant="contained" onClick={fetchStock}>Apply</Button>
          </Grid>

          <Grid item xs={6} md={2}>
            <Button fullWidth variant="outlined" onClick={resetFilters}>Reset</Button>
          </Grid>

        </Grid>
      </Paper>

      {loading && <Box py={4} textAlign="center"><CircularProgress /></Box>}
      {error   && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {!loading && !error && data.length === 0 && (
        <Alert severity="info">No return bikes found for "{activeFilterLabel()}".</Alert>
      )}

      {/* DATA TABLES */}
      {!loading && data.map((loc, i) => (
        <Paper key={i} sx={{ mb: 3 }}>
          <Box sx={{ p: 2, background: "#1976d2", color: "#fff", fontWeight: 700 }}>
            📍 {loc.location} — {loc.total} return bike(s)
          </Box>

          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                <TableCell><b>#</b></TableCell>
                <TableCell><b>Model</b></TableCell>
                <TableCell><b>Engine</b></TableCell>
                <TableCell><b>Chasis</b></TableCell>
                <TableCell><b>Colour</b></TableCell>
                <TableCell><b>Price</b></TableCell>
                <TableCell><b>From Location</b></TableCell>
                <TableCell><b>To Location</b></TableCell>
                <TableCell><b>Return Date</b></TableCell>
                <TableCell><b>Status</b></TableCell>
                <TableCell><b>Action</b></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loc.bikes.map((b, idx) => (
                <TableRow key={b._id} hover>
                  <TableCell sx={{ color: "#999" }}>{idx + 1}</TableCell>
                  <TableCell>{b.model}</TableCell>
                  <TableCell>{b.engine}</TableCell>
                  <TableCell>{b.chasis}</TableCell>
                  <TableCell>{b.colour}</TableCell>
                  <TableCell>₹{b.purchasePrice}</TableCell>
                  <TableCell>
                    {b?.transferHistory?.length > 0
                      ? b.transferHistory[b.transferHistory.length - 1]?.fromLocation
                      : "—"}
                  </TableCell>
                  <TableCell>
                    {b?.transferHistory?.length > 0
                      ? b?.otherLocationName
                      : "—"}
                  </TableCell>
                  <TableCell>
                    {b.returnDate
                      ? new Date(b.returnDate).toLocaleDateString("en-IN")
                      : "—"}
                  </TableCell>
                  <TableCell sx={{ color: "#d32f2f", fontWeight: 700 }}>{b.status}</TableCell>
                  <TableCell>
                    <Button size="small" variant="contained" onClick={() => handleView(b._id)}>
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      ))}

      {/* VIEW MODAL */}
      <Dialog open={openView} onClose={() => setOpenView(false)} fullWidth maxWidth="md">
        <Box p={3} sx={{ background: "#f1f5f9" }}>
          <Typography variant="h5" fontWeight={700} mb={3}>Bike Full Details</Typography>

          {!viewData ? (
            <Box textAlign="center" py={4}><CircularProgress /></Box>
          ) : (
            <Grid container spacing={2}>

              <Grid item xs={12} md={6}>
                <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
                  <Typography variant="h6" fontWeight={700} mb={2}>🏍 Bike Info</Typography>
                  {[
                    ["Model",    viewData?.stockDetails?.model],
                    ["Engine",   viewData?.stockDetails?.engine],
                    ["Chasis",   viewData?.stockDetails?.chasis],
                    ["Colour",   viewData?.stockDetails?.colour],
                    ["SKU",      viewData?.stockDetails?.skuCode],
                    ["Key No",   viewData?.stockDetails?.keyNumber],
                    ["Location", viewData?.stockDetails?.location],
                    ["to Location", viewData?.stockDetails?.otherLocationName],
                  ].map(([label, val]) => (
                    <Box key={label} display="flex" justifyContent="space-between" mb={0.5}>
                      <Typography color="text.secondary">{label}</Typography>
                      <Typography fontWeight={600}>{val || "—"}</Typography>
                    </Box>
                  ))}
                  <Box display="flex" justifyContent="space-between" mb={0.5}>
                    <Typography color="text.secondary">Purchase Price</Typography>
                    <Typography fontWeight={700} color="green">₹{viewData?.stockDetails?.purchasePrice || 0}</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between" mb={0.5}>
                    <Typography color="text.secondary">Ex-Showroom</Typography>
                    <Typography fontWeight={700}>₹{viewData?.stockDetails?.exShowroomPrice || 0}</Typography>
                  </Box>
                  <Box display="flex" justifyContent="space-between">
                    <Typography color="text.secondary">Status</Typography>
                    <Typography color="error" fontWeight={700}>{viewData?.currentStatus}</Typography>
                  </Box>
                </Paper>
              </Grid>

              <Grid item xs={12} md={6}>
                <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
                  <Typography variant="h6" fontWeight={700} mb={2}>👤 Created Info</Typography>
                  <Typography><b>Name:</b> {viewData?.stockDetails?.createdBy?.name}</Typography>
                  <Typography><b>Email:</b> {viewData?.stockDetails?.createdBy?.email}</Typography>
                  <Typography mt={1}>
                    <b>Date:</b>{" "}
                    {viewData?.stockDetails?.date
                      ? new Date(viewData.stockDetails.date).toLocaleString()
                      : "—"}
                  </Typography>
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
                  <Typography variant="h6" fontWeight={700} mb={2}>🔁 Transfer History</Typography>
                  {viewData?.transferHistory?.length > 0 ? (
                    viewData.transferHistory.map((t, i) => (
                      <Box key={i} sx={{ p: 2, mb: 1, borderRadius: 2, background: "#f8fafc", border: "1px solid #e2e8f0" }}>
                        <Typography fontWeight={600}>{t.fromLocation} ➝ {t.toLocation}</Typography>
                        <Typography variant="body2" color="text.secondary">By: {t.transferredBy?.name}</Typography>
                        <Typography variant="caption">{new Date(t.date).toLocaleString()}</Typography>
                      </Box>
                    ))
                  ) : (
                    <Typography>No transfer history</Typography>
                  )}
                </Paper>
              </Grid>

              <Grid item xs={12}>
                <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3 }}>
                  <Typography variant="h6" fontWeight={700} mb={2}>💰 Sale Info</Typography>
                  {viewData?.saleDetails ? (
                    <Grid container spacing={2}>
                      <Grid item xs={6}><Typography><b>Customer:</b> {viewData.saleDetails.customerName}</Typography></Grid>
                      <Grid item xs={6}><Typography><b>Price:</b> ₹{viewData.saleDetails.salePrice}</Typography></Grid>
                      <Grid item xs={6}><Typography><b>Type:</b> {viewData.saleDetails.saleType}</Typography></Grid>
                    </Grid>
                  ) : (
                    <Typography color="text.secondary">Bike not sold yet</Typography>
                  )}
                </Paper>
              </Grid>

            </Grid>
          )}
        </Box>
      </Dialog>

    </Box>
  );
};

export default ReturnBike;
